
import { defineComponent } from 'vue-demi';
import DashboardTargetAccomplished from './DashboardTargetAccomplished.vue';
import DashboardAccomplishedSegment from './DashboardAccomplishedSegment.vue';
import { useRoute } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  components: {
    DashboardTargetAccomplished,
    DashboardAccomplishedSegment,
  },

  watch: {
    $route: function (to) {
      if (
        to?.fullPath.includes('/dashboard-brand-management/') &&
        to?.fullPath !== '/dashboard-brand-management/totals'
      ) {
        this.salesChannel.forEach((channel) => {
          this.fetchTargetAccomplishedBrands({
            brandCodes: [to.meta.code],
            name: this.channelName(channel.name),
            code: channel.code,
            filteredDateYYYYMM: null,
          });
        });
      }
    },
  },

  computed: {
    ...mapGetters('auth', { salesChannel: 'getSalesChannel' }),
    ...mapGetters('dashboardBrandManagement', {
      targetAccomplishedDtc: 'targetAccomplishedDtc',
      targetAccomplishedEcomm: 'targetAccomplishedEcomm',
      targetAccomplishedExport: 'targetAccomplishedExport',
      targetAccomplishedWholesale: 'targetAccomplishedWholesale',
      loadingTargetAccomplishedEcomm: 'loadingTargetAccomplishedEcomm',
      loadingTargetAccomplishedExport: 'loadingTargetAccomplishedExport',
      loadingTargetAccomplishedDtc: 'loadingTargetAccomplishedDtc',
      loadingTargetAccomplishedWholesale: 'loadingTargetAccomplishedWholesale',
      accessWholesale: 'accessWholesale',
      accessDtc: 'accessDtc',
      accessExport: 'accessExport',
      accessEcomm: 'accessEcomm',
      selectedchannel: 'selectedchannel',
    }),
  },

  methods: {
    setFunction(f: string) {
      return this[f + this.selectedchannel.name];
    },
    channelName(name: string) {
      return name[0].toUpperCase() + name.substring(1).toLowerCase();
    },

    ...mapActions('dashboardBrandManagement', {
      fetchTargetAccomplishedBrands: 'fetchTargetAccomplishedBrands',
    }),
  },

  mounted() {
    const route = useRoute();
    this.salesChannel.forEach((channel) => {
      this.fetchTargetAccomplishedBrands({
        brandCodes: [route?.meta?.code as number],
        name: this.channelName(channel.name),
        code: channel.code,
        filteredDateYYYYMM: null,
      });
    });
  },
});
